var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Biometry_1;
import React, { PureComponent } from 'react';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, eventListener, expression, oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, isEnumValid, isFunction } from '@philips-internal/oswald-ui-utils';
import { Button } from '../button/button.js';
import { Link } from '../link/link.js';
import { BiometryAPI } from './biometry-api.js';
import { BiometryStatus } from './biometry-constants.js';
import './biometry.css';
let Biometry = Biometry_1 = class Biometry extends PureComponent {
    constructor() {
        super(...arguments);
        this.onButtonClick = () => {
            const { onSubmit, status } = this.props;
            isFunction(onSubmit) && onSubmit(new SubmitEvent({ record: { record: status } }));
        };
        this.onLinkClick = () => {
            const { onCancel, status } = this.props;
            isFunction(onCancel) && onCancel(new SubmitEvent({ record: { record: status } }));
        };
    }
    getButtonText() {
        const { status = BiometryStatus.DEFAULT } = this.props;
        const texts = {
            [BiometryStatus.DEFAULT]: MessageService.translate(this.props.captureExpression ?? Biometry_1.defaultProps.captureExpression),
            [BiometryStatus.FAILED]: MessageService.translate(this.props.retryExpression ?? Biometry_1.defaultProps.retryExpression),
            [BiometryStatus.SUCCESS]: MessageService.translate(this.props.removeExpression ?? Biometry_1.defaultProps.removeExpression),
            [BiometryStatus.WAITING]: MessageService.translate(this.props.touchExpression ?? Biometry_1.defaultProps.touchExpression),
        };
        return texts[status] || null;
    }
    getHelpText() {
        const { status } = this.props;
        return status === BiometryStatus.FAILED
            ? MessageService.translate(this.props.notFoundExpression ?? Biometry_1.defaultProps.notFoundExpression)
            : null;
    }
    getClassName() {
        const { status } = this.props;
        return classNames({
            'c-biometry': true,
            [`c-biometry--${status}`]: isEnumValid(BiometryStatus, status),
        });
    }
    renderFingerprint() {
        return React.createElement("div", { className: "c-biometry__fingerprint", "x-contrast": "cl" });
    }
    renderButton() {
        const { enabled = Biometry_1.defaultProps.enabled, status } = this.props;
        const text = this.getButtonText();
        if (!text) {
            return null;
        }
        const props = {
            background: status === BiometryStatus.WAITING ? '#9e9e9e' : undefined,
            bold: true,
            className: 'c-biometry__custom-button',
            enabled: enabled && status !== BiometryStatus.WAITING,
            onClick: this.onButtonClick,
            theme: status === BiometryStatus.WAITING ? ButtonTheme.PRIMARY : ButtonTheme.OUTLINE,
        };
        return (React.createElement("div", { className: "c-biometry__button" },
            React.createElement(Button, { ...props, value: text })));
    }
    renderLink() {
        const { enabled = Biometry_1.defaultProps.enabled, status, cancelExpression } = this.props;
        if (status !== BiometryStatus.WAITING) {
            return null;
        }
        return (React.createElement(Link, { className: "c-biometry__custom-link", enabled: enabled, onClick: this.onLinkClick, value: cancelExpression }));
    }
    renderText() {
        const { notFoundExpression = Biometry_1.defaultProps.notFoundExpression, } = this.props;
        return React.createElement("span", null, MessageService.translate(notFoundExpression));
    }
    renderBottom() {
        const { status } = this.props;
        let content = null;
        if (status === BiometryStatus.WAITING) {
            content = this.renderLink();
        }
        if (status === BiometryStatus.FAILED) {
            content = this.renderText();
        }
        if (!content) {
            return null;
        }
        return React.createElement("div", { className: "c-biometry__help-text" }, content);
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() },
            this.renderFingerprint(),
            this.renderButton(),
            this.renderBottom()));
    }
};
Biometry.propTypes = {
    cancelExpression: expression,
    captureExpression: expression,
    enabled: bool,
    notFoundExpression: expression,
    onCancel: eventListener,
    onSubmit: eventListener,
    removeExpression: expression,
    retryExpression: expression,
    status: oneOf(enumValues(BiometryStatus)),
    touchExpression: expression,
};
Biometry.defaultProps = {
    cancelExpression: 'tws.biometry.cancel',
    captureExpression: 'tws.biometry.capture-fingerprint',
    enabled: true,
    notFoundExpression: 'tws.biometry.user-not-found',
    removeExpression: 'tws.biometry.remove',
    retryExpression: 'tws.biometry.retry',
    status: BiometryStatus.DEFAULT,
    touchExpression: 'tws.biometry.detect-touch',
};
Biometry = Biometry_1 = __decorate([
    AwesomeComponent({ api: BiometryAPI, type: ComponentType.DATA_ENTRY })
], Biometry);
export { Biometry, };
//# sourceMappingURL=biometry.js.map